@if (isOpen) {
  <div class="prepaid-code-overlay" (click)="close()" data-testid="prepaid-code-dialog">
    <div
      class="prepaid-code-dialog"
      role="dialog"
      aria-modal="true"
      aria-labelledby="prepaid-code-title"
      (click)="$event.stopPropagation()"
    >
      <div class="prepaid-code-dialog__header">
        <h3 id="prepaid-code-title" class="prepaid-code-dialog__title">Type the code instead</h3>
        <button
          type="button"
          class="prepaid-code-dialog__close"
          aria-label="Close"
          [disabled]="busy"
          (click)="close()"
        >
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
            <path
              d="M12 4L4 12M4 4L12 12"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
            />
          </svg>
        </button>
      </div>

      <p class="prepaid-code-dialog__hint" data-testid="prepaid-code-intro">
        {{ intro || 'Ask the customer for the 8-character code from their prepaid SMS or email.' }}
      </p>

      <label class="prepaid-code-dialog__label" for="prepaid-code-input">Redemption code</label>
      <input
        id="prepaid-code-input"
        type="text"
        class="prepaid-code-dialog__input"
        [class.prepaid-code-dialog__input--error]="!!error"
        data-testid="prepaid-code-input"
        inputmode="text"
        autocomplete="off"
        autocapitalize="characters"
        spellcheck="false"
        maxlength="9"
        placeholder="XXXX-XXXX"
        [value]="value"
        [disabled]="busy"
        [attr.aria-invalid]="!!error"
        (input)="onInput($event)"
        (keyup.enter)="submit()"
      />
      @if (error) {
        <p class="prepaid-code-dialog__error" role="alert" data-testid="prepaid-code-error">
          {{ error }}
        </p>
      }

      <div class="prepaid-code-dialog__actions">
        <button
          type="button"
          class="prepaid-code-dialog__btn prepaid-code-dialog__btn--secondary"
          [disabled]="busy"
          (click)="close()"
        >
          Cancel
        </button>
        <button
          type="button"
          class="prepaid-code-dialog__btn prepaid-code-dialog__btn--primary"
          data-testid="prepaid-code-find"
          [disabled]="!canFind"
          (click)="submit()"
        >
          {{ busy ? 'Finding…' : 'Find prepaid' }}
        </button>
      </div>
    </div>
  </div>
}
